const updates = [
  { time: '10分钟前', title: '某顶流艺人深夜发文回应近期争议，评论区瞬间沦陷', tag: '热', tagColor: 'bg-primary-500' },
  { time: '28分钟前', title: '热门综艺节目录制现场突发状况，导演组紧急调整流程', tag: '新', tagColor: 'bg-accent-500' },
  { time: '1小时前', title: '知名音乐人发布新专辑预告，歌迷期待值拉满', tag: '爆', tagColor: 'bg-primary-500' },
  { time: '2小时前', title: '热门影视剧大结局引发全网讨论，收视率再创新高', tag: '热', tagColor: 'bg-primary-500' },
  { time: '3小时前', title: '体育赛事直播中意外花絮走红，网友直呼名场面', tag: '', tagColor: '' },
  { time: '4小时前', title: '品牌代言人更换传闻持续发酵，官方尚未回应', tag: '', tagColor: '' },
  { time: '5小时前', title: '独家：某知名剧组内部矛盾曝光，拍摄进度或受影响', tag: '新', tagColor: 'bg-accent-500' },
  { time: '6小时前', title: '社交媒体平台算法更新，内容推荐机制迎来重大调整', tag: '', tagColor: '' },
];

const comments = [
  {
    avatar: '匿',
    name: '吃瓜群众甲',
    time: '2小时前',
    content: '这个瓜真是越吃越大啊！每天刷51黑料已经成了我的日常，更新速度比别的平台快太多了，而且内容质量也很高，基本上不会错过任何热点。',
    likes: 328,
  },
  {
    avatar: '瓜',
    name: '娱乐观察员',
    time: '5小时前',
    content: '不得不说51黑料网的资讯整合能力确实强，很多独家爆料都是这里首发。51黑料网页版用起来也很流畅，推荐给身边的朋友了。',
    likes: 256,
  },
  {
    avatar: '料',
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '凌晨三点还在刷51黑料网站首页的请举手！这里的黑料网入口太方便了，不用到处找，一个页面就能看到所有热门话题，吃瓜效率直接拉满。',
    likes: 189,
  },
];

const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20warm-toned%20editorial%20photography%20composition%20with%20vibrant%20coral%20red%20gradient%20background%20and%20abstract%20geometric%20shapes%2C%20modern%20magazine%20cover%20aesthetic%2C%20rich%20contrast%2C%20sophisticated%20warm%20lighting%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-01-51hl&orientation=landscape',
    tag: '独家爆料',
    title: '娱乐圈年度最大瓜：多角度看事件全貌',
    desc: '从多方信源交叉验证，还原事件来龙去脉，持续追踪最新进展。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20golden%20amber%20abstract%20editorial%20background%20with%20soft%20flowing%20gradients%20and%20organic%20curves%2C%20luxurious%20magazine%20layout%20style%2C%20elegant%20warm%20tones%2C%20refined%20art%20direction%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-02-51hl&orientation=landscape',
    tag: '深度专题',
    title: '综艺节目幕后揭秘：你不知道的制作故事',
    desc: '独家对话多位业内人士，揭开热门综艺背后的创作历程。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20red%20and%20cream%20abstract%20editorial%20design%20with%20overlapping%20translucent%20shapes%20and%20soft%20gradients%2C%20modern%20trendy%20aesthetic%2C%20sophisticated%20visual%20style%2C%20magazine%20quality%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-03-51hl&orientation=landscape',
    tag: '热点追踪',
    title: '体育圈大事件盘点：赛季精彩瞬间回顾',
    desc: '整理本季度体育圈最受关注的事件与人物，一网打尽。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20warm%20abstract%20editorial%20composition%20with%20flowing%20gradients%20from%20coral%20to%20cream%2C%20minimalist%20geometric%20elements%2C%20clean%20sophisticated%20design%2C%20high-end%20magazine%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-04-51hl&orientation=landscape',
    tag: '影视解读',
    title: '热播剧集深度解析：剧情走向与观众反响',
    desc: '从编剧、导演到演员表现，全方位解析当前热播剧集。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20editorial%20background%20with%20soft%20coral%20and%20amber%20gradients%2C%20delicate%20organic%20shapes%2C%20refined%20luxurious%20composition%2C%20modern%20art%20direction%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-05-51hl&orientation=landscape',
    tag: '音乐前沿',
    title: '下半年最值得期待的演出和音乐节',
    desc: '精选各地音乐节阵容与巡演信息，提前锁定你的音乐之旅。',
  },
];

export default function SectionGroupA() {
  return (
    <>
      <section id="updates" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新快讯</h2>
            <span className="text-xs text-foreground-400 ml-2">实时更新</span>
          </div>
          <div className="space-y-0 border border-background-200/70 rounded-xl overflow-hidden">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`flex items-start gap-3 md:gap-4 p-4 md:p-5 ${
                  i < updates.length - 1 ? 'border-b border-background-200/70' : ''
                } hover:bg-background-100/60 transition-colors cursor-pointer`}
              >
                <span className="text-xs text-foreground-400 whitespace-nowrap mt-0.5 min-w-[60px]">{item.time}</span>
                <span className="text-sm md:text-base text-foreground-800 flex-1 leading-relaxed">{item.title}</span>
                {item.tag && (
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium text-white ${item.tagColor} whitespace-nowrap`}>
                    {item.tag}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="comments" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">读者热评</h2>
            <span className="text-xs text-foreground-400 ml-2">精选留言</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {comments.map((item, i) => (
              <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm">
                    {item.avatar}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                    <div className="text-xs text-foreground-400">{item.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
                <div className="flex items-center gap-1 text-foreground-400 text-xs">
                  <i className="ri-heart-line w-3 h-3 flex items-center justify-center"></i>
                  <span>{item.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="carousel" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
            <span className="text-xs text-foreground-400 ml-2">深度解读</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.slice(0, 2).map((item, i) => (
              <div key={i} className={`${i === 0 ? 'lg:col-span-2' : ''} group cursor-pointer`}>
                <div className="relative aspect-[16/10] rounded-xl overflow-hidden mb-4">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium">{item.tag}</span>
                  </div>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-5">
            {carouselItems.slice(2).map((item, i) => (
              <div key={i} className="group cursor-pointer">
                <div className="relative aspect-[16/10] rounded-xl overflow-hidden mb-4">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">{item.tag}</span>
                  </div>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}